import { pageTitle } from 'ember-page-title';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "privacy.title") separator=" | "}}

  {{! Page Header }}
  <section class="page-header" aria-labelledby="privacy-title">
    <div class="container">
      <div class="section-header">
        <h1 id="privacy-title" class="section-header__title">{{t
            "privacy.title"
          }}</h1>
        <p class="section-header__description">
          {{t "privacy.subtitle"}}
        </p>
      </div>
    </div>
  </section>

  <section class="section" aria-labelledby="privacy-content-title">
    <div class="container">
      <div class="prose">
        <h2 class="sr-only" id="privacy-content-title">{{t
            "privacy.content_title"
          }}</h2>

        <h2>{{t "privacy.controller.title"}}</h2>
        <p>
          {{t "privacy.controller.text"}}
        </p>
        <address class="address-normal mb-4">
          <strong>DEVLOED.COM</strong><br />
          {{t "contact.company_info.legal_form"}}<br />
          Floridalaan 77 bus 10<br />
          1180 Ukkel, Belgium<br />
          {{t "contact.company_info.vat"}}
          BE 0759.557.312
        </address>

        <h2>{{t "privacy.data_collected.title"}}</h2>
        <p>{{t "privacy.data_collected.text"}}</p>
        <ul>
          <li>{{t "privacy.data_collected.item_name"}}</li>
          <li>{{t "privacy.data_collected.item_email"}}</li>
          <li>{{t "privacy.data_collected.item_company"}}</li>
          <li>{{t "privacy.data_collected.item_subject"}}</li>
          <li>{{t "privacy.data_collected.item_message"}}</li>
        </ul>

        <h2>{{t "privacy.purpose.title"}}</h2>
        <p>{{t "privacy.purpose.text"}}</p>

        <h2>{{t "privacy.legal_basis.title"}}</h2>
        <p>{{t "privacy.legal_basis.text"}}</p>

        <h2>{{t "privacy.processor.title"}}</h2>
        <p>{{t "privacy.processor.text"}}</p>

        <h2>{{t "privacy.transfer.title"}}</h2>
        <p>{{t "privacy.transfer.text"}}</p>

        <h2>{{t "privacy.retention.title"}}</h2>
        <p>{{t "privacy.retention.text"}}</p>

        <h2>{{t "privacy.rights.title"}}</h2>
        <p>{{t "privacy.rights.text"}}</p>
        <ul>
          <li>{{t "privacy.rights.access"}}</li>
          <li>{{t "privacy.rights.rectification"}}</li>
          <li>{{t "privacy.rights.erasure"}}</li>
          <li>{{t "privacy.rights.restriction"}}</li>
          <li>{{t "privacy.rights.portability"}}</li>
          <li>{{t "privacy.rights.objection"}}</li>
        </ul>
        <p>
          {{t "privacy.rights.contact_text"}}
          <LinkTo @route="contact">{{t "privacy.rights.contact_link"}}</LinkTo>.
        </p>

        <h2>{{t "privacy.complaint.title"}}</h2>
        <p>{{t "privacy.complaint.text"}}</p>
        <address class="address-normal mb-4">
          <strong>{{t "privacy.complaint.authority_name"}}</strong><br />
          {{t "privacy.complaint.authority_address"}}<br />
          <a
            href="https://www.dataprotectionauthority.be"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Belgian Data Protection Authority (opens in new window)"
          >www.dataprotectionauthority.be</a>
        </address>

        <h2>{{t "privacy.cookies.title"}}</h2>
        <p>{{t "privacy.cookies.text"}}</p>

        <h2>{{t "privacy.changes.title"}}</h2>
        <p>{{t "privacy.changes.text"}}</p>

        <p class="mt-8">
          <LinkTo @route="contact" class="btn btn--outline">
            {{t "privacy.contact_cta"}}
          </LinkTo>
        </p>
      </div>
    </div>
  </section>
</template>
